/**
 * LeanIQ flavor stock sync — async (Theme Editor + storefront).
 * Theme Editor Liquid often fakes sold-out inventory; this uses /products/{handle}.js.
 */
(function () {
  'use strict';

  function apply(btn, available) {
    if (!btn) return;
    var meta = btn.querySelector('[data-liq-flavor-meta]');
    var oos = !available;
    btn.classList.toggle('is-oos', oos);
    if (oos) btn.setAttribute('disabled', 'disabled');
    else btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled', oos ? 'true' : 'false');
    if (meta) meta.textContent = oos ? 'Out of stock' : '30-serving tub';
  }

  function syncRoot(root) {
    if (!root) return;
    var handle = root.getAttribute('data-liq-product-handle') || 'lean-iq';
    var url = '/products/' + encodeURIComponent(handle) + '.js?v=' + Date.now();
    fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (product) {
        var variants = product.variants || [];
        root.querySelectorAll('[data-liq-flavor]').forEach(function (btn) {
          var id = String(btn.getAttribute('data-liq-variant-id') || '').replace(/^.*\//, '');
          if (!id) return;
          var match = null;
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === id) {
              match = variants[i];
              break;
            }
          }
          if (!match) {
            apply(btn, false);
            return;
          }
          apply(btn, !!match.available);
        });
        root.dataset.liqFlavorSynced = '1';
        root.dispatchEvent(new CustomEvent('liq:flavor-stock-synced', { bubbles: true }));
      })
      .catch(function () {});
  }

  function syncAll() {
    document.querySelectorAll('[data-liq-flavors]').forEach(syncRoot);
  }

  window.liqSyncFlavorStock = syncAll;

  function boot() {
    syncAll();
    if (window.Shopify && Shopify.designMode) {
      window.setTimeout(syncAll, 300);
      window.setTimeout(syncAll, 1000);
      window.setTimeout(syncAll, 2500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(syncAll, 0);
    window.setTimeout(syncAll, 250);
    window.setTimeout(syncAll, 800);
  });
  document.addEventListener('shopify:section:select', function () {
    window.setTimeout(syncAll, 0);
    window.setTimeout(syncAll, 250);
  });
  document.addEventListener('shopify:block:select', function () {
    window.setTimeout(syncAll, 0);
  });
})();
